import React from 'react'
import { getClassNameModern } from '../../../../../utils/getClassNameFromStyle'
import { useInView } from '../../../../hooks/useInView'
import { InviewOptions } from '../../blocksState'
import { JotformBlockClassNames } from './jotform.state'

export const jotformBlockClasses: JotformBlockClassNames = {
  // DEFAULTS
  block: 'block block--jotform block--wysiwyg container--m gutter--m',
  inview: 'block--inview',
  inner: 'block__inner',
  header: 'block__header',
  label: 'block__label label--m',
  title: 'block__title title--xl',
  intro: 'block__intro',
  content: 'block__content',

  // BLOCK SPECIFIC
}

export const JotformBlockLayout = {
  Block: (props: { index: number; inview?: InviewOptions; children?: React.ReactNode }): JSX.Element => {
    const { index, inview, children } = props
    const classes = jotformBlockClasses
    const { inView, ref } = useInView(
      { threshold: 0.1 },
      (inview) => console.debug("JotformBlockLayout inView:", inview),
      !inview?.triggerOnce
    )
    return (
      <section
        key={`block-${index}`}
        id={`io-${index}`}
        ref={ref}
        className={getClassNameModern(classes, 'block', 'container') + ' ' + (inView ? getClassNameModern(classes, 'inview', 'inview') : '')}
      >
        {children}
      </section>
    )
  },
  Inner: (props: { children?: React.ReactNode }): JSX.Element => {
    const { children } = props
    return (
      <div className={getClassNameModern(jotformBlockClasses, 'inner', 'mw-container-s mx-auto px-gutter')}>
        {children}
      </div>
    )
  },
  Content: (props: { label?: string; title?: string; intro?: string; children?: React.ReactNode }) => {
    const { label, title, intro, children } = props
    return (
      <>
        {(label || title || intro) && (
          <header className={getClassNameModern(jotformBlockClasses, 'header', '')}>
            {label && (
              <p className={getClassNameModern(jotformBlockClasses, 'label', 'fs-6 text-primary text-uppercase')}>
                {label}
              </p>
            )}
            {title && <h2 className={getClassNameModern(jotformBlockClasses, 'title', 'h2 mb-3')}>{title}</h2>}
            {intro && (
              <div
                className={getClassNameModern(jotformBlockClasses, 'intro', 'text--styled lead mb-3')}
                dangerouslySetInnerHTML={{ __html: intro }}
              />
            )}
          </header>
        )}

        <div className={getClassNameModern(jotformBlockClasses, 'content', '')}>{children}</div>
      </>
    )
  },
}
